<template>
  <div>
    <form v-on:submit.prevent="$emit('search', search)">
      <v-layout v-if="noSearch == null">
        <v-text-field
          v-model="search"
          solo
          label="Search"
          prepend-inner-icon="mdi-search"
          clearable
        />
        <v-btn
          class="ml-3 mt-1"
          color="primary"
          icon
          large
          @click="$emit('search', search)"
        >
          <v-icon>mdi-find-replace</v-icon>
        </v-btn>
      </v-layout>
    </form>
    <v-list :loading="loading">
      <div v-for="(item, index) in items" :key="index">
        <v-list-item two-line>
          <v-list-item-action>
            <v-checkbox
              v-model="item.select"
              @change="($event) => onChangeCheckbox(item, $event)"
            ></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <slot name="title" :item="item">
                {{ item[itemText] }}
              </slot>
            </v-list-item-title>
            <v-list-item-subtitle v-if="itemSubtitle != undefined">
              <slot name="subtitle" :item="item">
                {{ item[itemSubtitle] }}
              </slot>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
      </div>
    </v-list>
    <div v-if="noPagination == undefined" class="text-center">
      <v-pagination
        :value="page"
        :length="pageLength"
        @input="onChangePage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array },
    items: { type: Array },
    noSearch: {},
    itemValue: {},
    loading: {},
    itemText: {},
    itemSubtitle: {},
    page: {},
    pageLength: {},
    noPagination: {},
  },
  data() {
    return {
      search: null,
    };
  },
  watch: {
    items() {
      this.setSelectInItems();
    },
  },
  methods: {
    setSelectInItems() {
      this.items.forEach((item) => {
        const selected = this.value.find((v) => v == item[this.itemValue]);
        item.select = selected;
      });
    },
    onChangePage(page) {
      this.$emit("change-page", page);
      this.setSelectInItems();
    },
    onChangeCheckbox(row, select) {
      const value = row[this.itemValue];
      const item = this.value.find((v) => v == value);
      if (select) {
        if (!item) this.value.push(value);
      } else {
        this.value.splice(this.value.indexOf(item), 1);
      }
    },
    mounted() {
      this.setSelectInItems();
    },
  },
};
</script>

<style>
</style>